import React from 'react'
import { observable, reaction, makeObservable } from 'mobx'
import { observer, inject } from 'mobx-react'
import { Form, Item, TextArea } from 'semantic-ui-react'
import { toast } from 'react-toastify'
import { ccpProvider } from 'core/CcpProvider'

class Notes extends React.Component {
  loading = false

  state = {
    emailId: null,
    name: '',
    job: '',
    hobbies: '',
    otherInfo: '',
    dates: '',
    creditSitesPurchased: '',
  }

  constructor(props) {
    super(props)

    makeObservable(this, {
      loading: observable
    })
  }

  componentDidMount() {
    const { actions, store } = this.props
    this.loading = true

    // Once data is loaded, add it to local state
    this.dispose = reaction( () => store.conversation && store.conversation.otherUserDetails, async details => {
      if(!details) { //no conversation in store
        return
      }

      this.setState({
        emailId: details.emailId,
        name: details.name,
        job: details.job,
        hobbies: details.hobbies,
        otherInfo: details.otherInfo,
        dates: details?.dates || ''
      })

      const [response, error] = await actions.ccp.getUserData(store.conversation.otherUserUid, store.conversation.identifier)
      if (error) {
        toast.error('Previous sites interacted didn\'t load.')
      } else {
        const { creditSitesPurchased } = response
        this.setState({ creditSitesPurchased })
      }
    }, {
      fireImmediately: true,
    })
    this.loading = false
  }

  componentWillUnmount() {
    // Stop listening to changes
    this.dispose()
  }

  handleSubmit = () => {
    const { actions, store } = this.props

    this.loading = true
    actions.ccp.updateUserData(store.conversation.otherUserUid, {...this.state})
      .then(([, error]) => {
        if(error) {
          toast.error('We couldn\'t save your notes, please try again')
        } else {
          toast.success('Your notes were saved successfully')
        }
        this.loading = false
      })
  }

  handleChange = (e, { name, value }) => {
    this.setState({
      [name]: value
    })
  }

  render() {
    return (
      <Item.Group className="chat-notes">
        <Form size="tiny" onSubmit={this.handleSubmit} loading={this.loading}>
          <Form.Field>
            <label>Previous sites interacted</label>
            <TextArea
              type="text"
              name="creditSitesPurchased"
              rows="1"
              value={this.state.creditSitesPurchased || ''}
              readOnly={true}
            />
          </Form.Field>
          <Form.Field>
            <label>Name</label>
            <TextArea
              type="text"
              name="name"
              rows="1"
              placeholder="Enter name..."
              value={this.state.name || ''}
              onChange={this.handleChange}
              readOnly={!this.state.emailId}
            />
          </Form.Field>
          <Form.Field>
            <label>Job</label>
            <TextArea
              type="text"
              name="job"
              rows="1"
              placeholder="Enter job..."
              value={this.state.job || ''}
              onChange={this.handleChange}
              readOnly={!this.state.emailId}
            />
          </Form.Field>
          <Form.Field>
            <label>Hobbies</label>
            <TextArea
              type="text"
              name="hobbies"
              rows="1"
              placeholder="Enter hobbies..."
              value={this.state.hobbies || ''}
              onChange={this.handleChange}
              readOnly={!this.state.emailId}
            />
          </Form.Field>
          <Form.Field>
            <label>Dates/Meets</label>
            <TextArea
              type="text"
              name="dates"
              placeholder="Enter dates/meets..."
              value={this.state.dates || ''}
              onChange={this.handleChange}
              readOnly={!this.state.emailId}
            />
          </Form.Field>
          <Form.Field>
            <label>Other info</label>
            <TextArea
              type="text"
              name="otherInfo"
              placeholder="Enter other details..."
              value={this.state.otherInfo || ''}
              onChange={this.handleChange}
              readOnly={!this.state.emailId}
            />
          </Form.Field>
          <Form.Button type="submit" size="small" color='facebook' style={{ fontWeight: 'normal' }} disabled={!this.state.emailId}>
            Update profile
          </Form.Button>
        </Form>
      </Item.Group>
    )
  }
}

Notes.propTypes = {}

export default inject('actions', 'store')(observer(Notes))
